module.exports = __webpack_public_path__ + "media/images/icon__community@3x-b1f5d22b6ac6b92f640ed0c3c31e0d12.png";